module.exports = __webpack_public_path__ + "img/title1.83a2f28e.png";